import React from 'react';
import {Grid} from "@material-ui/core";
import styled from "styled-components";
import {Colors} from "../../../theme/colors";
import emptyPublisherLogo from "../../../img/empty-publisher-logo.png";
import {SubmittedModel} from "../../../models/submitted.model";
import BookStatus from "../../publisher/book-status";
import {useTranslation} from "react-i18next";
import {PublisherDetailsDialog} from "../../shared/publisher-details-dialog";
import {ApplicationStatusEnum} from "../../../models/application-status.enum";

export const ApplicationSent: React.FC<{ application: SubmittedModel, style?: any, updateStatus?: any }> = ({
                                                                                                                style,
                                                                                                                application,
                                                                                                                updateStatus
                                                                                                            }) => {
    const [openPublisherDetails, setOpenPublisherDetails] = React.useState(false);
    const {t} = useTranslation(['author', 'common']);

    const getStatusColor = (status: string) => {
        if (status === 'PubNotWant' || status === 'AutNotWant' || status === 'Failed') {
            return 'red';
        } else {
            return 'green';
        }
    }

    return (
        <Grid item container xs={12} sm={6} md={6} lg={3} direction={"column"} style={{...style, marginBottom: '1rem'}}>
            <StyledGrid item container direction={"column"}>
                <Grid item>
                    <StyledStatus>{t('applicationSent.status')} <span
                        className={getStatusColor(application.status)}>{t(`common:applicationStatus.status${application.status}`)}</span></StyledStatus>
                </Grid>
                <Grid item>
                    <StyledDate>{t('common:sent')}: {new Date(application.created).toLocaleString()}</StyledDate>
                </Grid>
                <Grid item>
                    <StyledDate>{t('common:updated')}: {new Date(application.updated).toLocaleString()}</StyledDate>
                </Grid>
                <Grid item container justifyContent={"center"}>
                    <StyledImg onClick={() => setOpenPublisherDetails(true)} style={{cursor: 'pointer'}}
                               src={application.publisher?.logo?.file || emptyPublisherLogo}/>
                </Grid>

                <Grid item>
                    <StyledTitle onClick={() => setOpenPublisherDetails(true)}
                                 style={{cursor: 'pointer'}}>{application.publisher?.name}</StyledTitle>
                </Grid>

                <PublisherDetailsDialog open={openPublisherDetails} publisherId={application.publisher.id}
                                        showContactData={[ApplicationStatusEnum.PubWant, ApplicationStatusEnum.AutWant, ApplicationStatusEnum.AutNotWant, ApplicationStatusEnum.Success, ApplicationStatusEnum.Failed].includes(application.status)}
                                        handleClose={() => {
                                            setOpenPublisherDetails(false)
                                        }}/>

                <Grid item style={{marginTop: '1rem'}}>
                    <BookStatus status={application.status} id={application.id} bookmarked={false}
                                updateStatus={(id) => {
                                    updateStatus();
                                }} vertical={false}/>
                </Grid>
            </StyledGrid>
        </Grid>
    );
}
const StyledGrid = styled(Grid)`
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 1rem;
  height: 100%;
`;

const StyledStatus = styled('p')`
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0 0 15px;

  span {
    font-size: 0.8rem;
    padding: 2px 5px;
    border-radius: 10px;
    margin-left: 5px;

    &.green {
      border: 1px solid #B3DAC7;
      background-color: #EBF5F0;
      color: ${Colors.green};
    }

    &.red {
      background-color: #FFECEC;
      border: 1px solid #FFD7D7;
      color: ${Colors.dangerRedHover};
    }
  }
`;

const StyledDate = styled('p')`
  font-size: 0.9rem;
  color: ${Colors.grayText};
  font-weight: 400;
`;

const StyledImg = styled('img')`
  height: 135px;
  padding: 24px 0;
  object-fit: contain;
`;

const StyledTitle = styled('h6')`
  color: ${Colors.violet};
  font-size: 1.3rem;
  text-align: center;
`;
